import { query, request } from '@/utils/request';

/**
 * 获取异常业务枚举信息
 */
export async function getExceptionRecordType (params) {
  return request('/zlb/operation/exception/record/enumdictionary', {
    params
  });
}



/**
 * 异常处理操作
 */
export async function handleExceptionRecord (data) {
  return request('/zlb/operation/exception/record/deal', {
    data,
    method: 'POST'
  });
}

/**
 * 查询浙政钉人员数据信息
 */
export async function searchDDBindRelationship (data) {
  return request('/zlb/operation/user/bind/userList', {
    data,
    method: 'POST'
  });
}

/**
 * 修改浙政钉人员数据信息
 */
export async function modifyIdInfo (data) {
  return request('/zlb/operation/user/bind/updateOutAccountId', {
    data,
    method: 'POST'
  });
}

/**
 * 分页查询异常记录
 */
export async function getExceptionRecordList (data) {
  return request('/zlb/operation/exception/record/pagingStatistics', {
    data,
    method: 'POST'
  });
}

/**
 * 获取异常详情列表数据
 */
export async function getExceptionDetailList (data) {
  return request('/zlb/operation/exception/record/paging', {
    data,
    method: 'POST'
  });
}
/**
 * 批量处理异常
 */
export async function handlingExceptions (data) {
  return request('/zlb/operation/exception/record/batchDeal', {
    data,
    method: 'POST'
  });
}
/**
 * 处理异常
 */
export async function handlingException (data) {
  return request('/zlb/operation/exception/record/deal', {
    data,
    method: 'POST'
  });
}

/**
 * 已删除单位列表
 */
export async function fetchDeleteOrgList (params) {
  return query('/api/zlbuser/institution/list/deleted', {
    params,
  });
}
